import React, { useState } from 'react'
import ModalVideo from 'react-modal-video'
import style from './modal.mod.scss'
import Play from '@svgs/playButton.svg'
import { isBrowser } from '@context/themeContext'
import ReactDOM from 'react-dom'
import { gtmPush } from '@helpers/gtmHelpers'

const Modal = ({ video = false, placement = 'default' }) => {
  const [isOpen, setOpen] = useState(false)

  const modifiers = [
    style['modal--' + placement.toLowerCase().replace(/ /gi, '-')]
  ]

  const appRoot = isBrowser()
    ? window.document.querySelector('#___gatsby')
    : false

  return (
    <div className={[style.modal, ...modifiers].join(' ')}>
      <div className={style.modal__wrap}>
        {video &&
          isBrowser() &&
          ReactDOM.createPortal(
            <ModalVideo
              isOpen={isOpen}
              channel={video.provider}
              autoplay="true"
              videoId={video.providerUid}
              onClose={() => setOpen(false)}
            />,
            appRoot
          )}
        <button
          aria-label={`Open modal and play video: ${video.title}`}
          className={[style.modal__button, 'swiper-no-swiping'].join(' ')}
          onClick={() => {
            gtmPush({
              event: `video-engagement`,
              label: `Video Model Click`,
              value: `${video.title}`
            })
            setOpen(true)
          }}
        >
          <Play />
        </button>
      </div>
    </div>
  )
}

export default Modal
